import React from 'react'
import axios from 'axios'

import i18next from '@theme/translations'
import PageTitle from '@theme/components/PageTitle'
import Input from '@theme/components/fields/Input'
import Button from '@theme/components/Button'
// import LoginForm from '@theme/components/forms/LoginForm'
// import useLoginRedirect from '@theme/hooks/useLoginRedirect'
// import siteConfig from '@theme/utils/siteConfig'

const BottleVerification = () => {

  const [isLoading, setIsLoading] = React.useState(false);;
  const [error, setError] = React.useState("");
  const [response, setResponse] = React.useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    // wipe any previous verifications
    setError("");
    setResponse("");

    console.log(e.target.bottle_id.value);

    try {
      const response = await axios.get(`https://iproofapi.com/api/scan/web/${e.target.bottle_id.value}?bypassSentry=true`);
      setResponse(`${i18next.t("bottle-verification-success")}${response.data.data.description}`);
    } catch (error) {
      const status = error.response?.data?.status;
      if(status >= 400 && status < 500) {
        if(error.response?.data?.message == 'Id not of valid length') {
          setError(i18next.t('bottle-verification-invalid-length'))
        }
        else {
          setError(i18next.t('bottle-verification-not-valid'))
        }
      } else if(status != 200) {
        setError(i18next.t('bottle-verification-error'))
      }
      console.error(error.response?.data);
    }
    setIsLoading(false);
    return false;
  };

  return (
    <>
      <PageTitle title="Bottle Verification" />
      <div className="public-form-page">

        <div className="public-form-page-inner welcome-inner w-full md:w-3/4 mt-6 mx-auto">

          {error && (
            <div className="msg login-error-message px-2 red my-8">
              {/* An error occurred verifying this bottle. Please try again. */}
              {error}
            </div>
          )}
          {response && (
            <div className="msg font-bold px-2 my-8">
              {response}
            </div>
          )}
          {!error && !response && (
            <div className="msg px-2 my-8">
              Please enter your Bottle ID below to authenticate.
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <Input
              id="bottle_id"
              name="bottle_id"
              className="px-2 mb-6"
              label={i18next.t('Bottle ID')}
              type="text"
            />

            <div className="button-outer-container">
              <Button
                className="mt-10 mx-auto"
                type="submit"
                disabled={isLoading}
                isLoading={isLoading}
              >
                Validate Bottle ID
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default BottleVerification

// export const Head = () => {
//   const settings = useC7Settings()

//   return <title>{settings.companyName} - Login</title>
// }
